var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-sidebar sidebar-shadow", class: _vm.sidebarbg },
    [
      _c(
        "div",
        { staticClass: "app-sidebar-content" },
        [
          _c(
            "VuePerfectScrollbar",
            {
              staticClass: "app-sidebar-scroll left-sidebar-menu",
              attrs: { tabindex: "-1" },
            },
            [
              _c("div", { staticClass: "sidebar-top-bar" }, [
                _c("div", { staticClass: "sidebar-top-bar-btngroup" }, [
                  _vm._v(" 메뉴 바로가기 "),
                ]),
                _c(
                  "div",
                  { staticClass: "sidebar-top-bar-close" },
                  [
                    _c("q-btn", {
                      attrs: { flat: "", color: "gray", icon: "close" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleMobile("closed-sidebar-open")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("c-sidebar-menu", {
                attrs: { showOneChild: "", menu: _vm.permission_routers },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }